<template>
  <div class="container">
    <div class="header">
      <van-icon class="header-return" name="arrow-left" size="25" color="#333333" @click="onClickHeaderReturn()"/>
      Set Flavor
    </div>

    <div class="set-flavor-wrap">
      <div class="card">
        <FlavorDeviceSpecification :series-data="pieChartData" :product-image="productImage"
            @onChangeDevice="onChangeDevice"/>
      </div>

      <div class="card" v-if="ingredientOptions">
        <IngredientsEditor
            label="Ingredients"
            :idle-ingredient="idleTerpenes"
            :ingredient-value="ingredients"
            :ingredient-options="filterOptions"
            @onItemDelete="onIngredientItemDelete"
            @onItemChange="onIngredientItemChange"
            @onItemAdd="onIngredientItemAdd"
            @onPercentValueChange="onPercentValueChange"
            @onBlur="onBlur"
            @onFocus="onFocus"/>
      </div>
      <div class="card" v-if="terpenesOptions">
        <IngredientsEditor
            label="Terpenes"
            :idle-ingredient="idleTerpenes"
            :ingredient-value="terpenes"
            :ingredient-options="filterTerpenesOptions"
            @onItemDelete="onIngredientItemDelete"
            @onItemChange="onIngredientItemChange"
            @onItemAdd="onIngredientItemAdd"
            @onPercentValueChange="onPercentValueChange"
            @onBlur="onBlur"
            @onFocus="onFocus"/>
      </div>

      <FlavorSelect v-model="flavorName" label="Flavor" :tags="flavorLabels" @tagChange="onTagChange"/>

      <PopupChooseProduct v-model="showSelectDevicePopup"
          :my-products="myProducts"
          @onSelectProduct="onProductChange"
          @onApplyDevice="onApplyDevice"
          @onClose="onCloseChooseDevicePopup"
      />
      <CustomizationBottomOperate
          :text="buttonText"
          @onNext="onCreateFlavor"
          @onDelete="onDeleteClick"
          :show-delete="showDelete"/>

      <DialogTips
          v-model="showDeleteDialog"
          left-text="Cancel"
          right-text="Confirm"
          title="Delete Flavor"
          message="Delete this flavor?"
          @onLeftClick="showDeleteDialog=false"
          @onRightClick="onDeleteFlavor"
      />
    </div>
  </div>
</template>

<script>
import FlavorDeviceSpecification from "@/components/flavor/FlavorDeviceSpecification.vue";
import IngredientsEditor from "@/components/IngredientsEditor.vue";
import produce from "@/api/produce";
import log from "@/util/log";
import FlavorSelect from "@/components/set-flavor/FlavorSelect.vue";
import CustomizationBottomOperate from "@/components/customization/CustomizationBottomOperate.vue";
import PopupChooseProduct from "@/components/customization/PopupChooseProduct.vue";
import DialogTips from "@/components/DialogTips.vue";

export default {
  name: "SetFlavor",
  components: {
    DialogTips,
    PopupChooseProduct,
    CustomizationBottomOperate,
    FlavorSelect,
    IngredientsEditor,
    FlavorDeviceSpecification
  },
  data() {
    return {
      ingredientOptions: [
        // { text: "qq", value: "12323", id: 1 },
        // { text: "aa", value: "123323", id: 2 }
      ],

      ingredients: [{ text: "", value: "", id: 0 }],
      idleIngredient: 100,
      serverData: null,
      otherIngredient: {
        text: "Other",
        value: "",
        id: -1000
      },

      terpenesOptions: [],
      terpenes: [{
        text: "Other",
        value: "100",
        id: -1000
      }],
      idleTerpenes: 100,
      otherTerpenes: {
        text: "Other",
        value: "",
        id: -1000
      },

      flavorLabels: [],
      flavorName: "",

      myProducts: [],
      showSelectDevicePopup: false,

      productImage: null,
      productId: 0,
      isInit: false,
      showDelete: false,
      showDeleteDialog: false
    };
  },
  computed: {
    filterOptions() {
      const selectedId = this.ingredients
          .filter(item => item.id > 0)
          .map(item => item.id);
      return this.ingredientOptions.filter(
          item => !selectedId.includes(item.value)
      );
    },
    filterTerpenesOptions() {
      const selectedId = this.terpenes
          .filter(item => item.id > 0)
          .map(item => item.id);
      return this.terpenesOptions.filter(
          item => !selectedId.includes(item.value)
      );
    },
    pieChartData() {
      const idle = this.calcAllIdleIngredient();
      return [].concat(this.ingredients).concat(this.terpenes)
          .filter(item => (item.id > 0 || (idle > 0 ? item.id === -1000 : false)) && item.value > 0)
          .map(item => {
            if (item.id === -1000) {
              item.value = idle;
            }
            return { value: item.value || 0, name: item.text };
          }).sort((prev, current) => {
            return current.value - prev.value;
          });
    },
    buttonText() {
      if (this.$route.query.id) {
        return "Apply";
      }
      return "Create";
    }
  },
  methods: {
    onClickHeaderReturn() {
      this.$router.back();
    },

    getTypeData(type) {
      let list = null;
      switch (type) {
        case "ingredients":
          list = this.ingredients;
          break;
        case "terpenes":
          list = this.terpenes;
          break;
      }
      return list;
    },

    getOtherType(type) {
      let list = null;
      switch (type) {
        case "ingredients":
          return "terpenes";
        case "terpenes":
          return "ingredients";
      }
    },
    getOtherData(type) {
      let list = null;
      switch (type) {
        case "ingredients":
          list = this.otherIngredient;
          break;
        case "terpenes":
          list = this.otherTerpenes;
          break;
      }
      return list;
    },

    setIdle(type, idle) {
      switch (type) {
        case "ingredients":
          this.idleIngredient = idle;
          break;
        case "terpenes":
          this.idleTerpenes = idle;
          break;
      }
    },
    getFilterOptionData(type) {
      let list = [];
      switch (type) {
        case "ingredients":
          list = this.filterOptions;
          break;
        case "terpenes":
          list = this.filterTerpenesOptions;
          break;
      }
      return list;
    },
    onIngredientItemDelete(type, index, optionIndex, selectedItem) {
      let list = this.getTypeData(type);
      if (list == null) {
        return;
      }
      list.splice(index, 1);
    },
    onIngredientItemChange(type, index, optionIndex, selectedItem) {
      let list = this.getTypeData(type);
      if (list == null) {
        return;
      }
      log("onIngredientItemChange");
      list[index].showSelectError = false;
      list[index].text = selectedItem.text;
      list[index].id = selectedItem.value;
      if (list[index].value > 0) {
        this.onBlur(type, index);
      }
    },
    onIngredientItemAdd(type) {
      if (this.validateIngredients(type)) {
        return;
      }

      if (this.validateIngredients(this.getOtherType(type))) {
        return;
      }

      const filterOption = this.getFilterOptionData(type);
      //是否选中完所有的选项了
      if (filterOption.length === 0) {
        return;
      }


      //是否还有剩余的百分比，没有剩余的了，直接移除other
      const idle = this.calcAllIdleIngredient(type, -1);

      if (idle <= 0) {
        return;
      }


      //如果还有剩余的
      const list = this.getTypeData(type);
      if (list == null) {
        return;
      }
      const otherIndex = list.findIndex(item => item.id === -1000);
      if (otherIndex !== -1) {
        list.splice(otherIndex, 1);
      }

      //看看有没有添加的条目
      const filterIdItem = list.filter(item => item.id <= 0);
      if (filterIdItem.length === 0) { //如果没添加，就直接加入一条
        list.push({ text: "", value: "", id: 0 });
        return;
      }
      //有添加过，找到最小的id，-1
      const findMinIds = filterIdItem
          .map(item => item.id)
          .reduce((prev, curr) => Math.min(prev, curr));
      list.push({ text: "", value: "", id: findMinIds - 1 });
    },

    onPercentValueChange(type, value, index) {

      const list = this.getTypeData(type);
      if (list == null) {
        return;
      }
      if (list[index].id === -1000) {
        return;
      }
      this.$set(
          list,
          index,
          Object.assign(list[index], {
            value: value,
            showInputError: false
          })
      );
      //一边输入
      if (this.idleIngredient === 0) {
        return;
      }
      const idle = this.calcIdleIngredient(type, index);
      this.setIdle("terpenes", idle);
      log(`输入完成后剩余的百分比 ${type} ${idle}`);
    },
    onFocus(type, index) {
      const idle = this.calcIdleIngredient(type, index);
      this.setIdle(type, idle);
    },
    onBlur(type, index) {
      let list = this.getTypeData(type);
      if (list == null) {
        return;
      }

      //离开焦点了，判断是否满足百分之一百
      const currentEditItem = list[index];
      if (currentEditItem.value == "" || currentEditItem.value <= 0) {
        return;
      }

      if (this.validateIngredients(type)) {
        return;
      }

      const allList = [].concat(this.ingredients).concat(this.terpenes);
      const result = allList
          .filter(item => item.id > 0)
          .map(item => item.value)
          .reduce((prev, current) => parseFloat(prev) + parseFloat(current), 0);
      log(`on blur 当前填入的百分比总合 ${result}`);

      const idle = 100 - result;
      // this.idleIngredient = idle;

      //如果有剩余的，加入other
      const otherIndex = this.terpenes.findIndex(item => item.id === -1000);
      if (idle <= 0) {
        if (otherIndex !== -1) {
          //没有剩余了，直接移除
          this.terpenes.splice(otherIndex, 1);
        }
        return;
      }

      const otherItem = this.otherTerpenes;

      if (otherIndex !== -1) {
        this.$set(
            this.terpenes,
            otherIndex,
            Object.assign(otherItem, { value: idle })
        );
      } else {
        otherItem.value = idle;
        this.terpenes.push(otherItem);
      }
    },
    calcIdleIngredient(type, index) {
      const list = this.getTypeData(type);
      if (list == null) {
        return 0;
      }
      const currentCalcList = list
          .filter((item, i) => item.id > 0 && index !== i);

      log(currentCalcList);
      log(`index = ${index}`);
      let otherList = [];
      //判断另一个剩余的
      if (type === "ingredients") {
        otherList = this.getTypeData("terpenes").filter((item, i) => item.id > 0);
      } else {
        otherList = this.getTypeData("ingredients").filter((item, i) => item.id > 0);
      }

      const result = otherList.concat(currentCalcList).map(item => item.value)
          .reduce(
              (prev, current) =>
                  (parseFloat(prev) || 0) + (parseFloat(current) || 0),
              0
          );
      log(`当前填入的百分比总合 calcIdleIngredient ${100 - result}`);

      return 100 - result;
    },
    calcAllIdleIngredient(type) {
      const result = [].concat(this.ingredients).concat(this.terpenes)
          .filter((item, i) => item.id > 0)
          .map(item => item.value)
          .reduce(
              (prev, current) =>
                  (parseFloat(prev) || 0) + (parseFloat(current) || 0),
              0
          );
      log(`当前填入的百分比总合 calcAllIdleIngredient ${100 - result}`);
      return 100 - result;
    },
    validateIngredients(type) {
      let list = this.getTypeData(type);
      if (list == null) {
        return true;
      }
      let findValueHasError = false;
      list.forEach((item, index) => {
        if ((item.value === "" || item.value === undefined || item.value <= 0) && item.id !== -1000) {
          findValueHasError = true;
          this.$set(
              list,
              index,
              Object.assign(item, { showInputError: true })
          );
        }
        //离开焦点了，判断是否满足百分之一百
        const selectedIngredientId = list[index].id;
        //-1000的时候给他通过
        const isSelectedIngredient =
            selectedIngredientId > 0 || selectedIngredientId === -1000;
        // log(`选择了成分？ ${isSelectedIngredient} ${index}`);
        if (!isSelectedIngredient) {
          //提示他要选择
          this.$set(
              list,
              index,
              Object.assign(list[index], { showSelectError: true })
          );
          findValueHasError = true;
        }
      });
      return findValueHasError;
    },

    onTagChange(index) {
      const flavorLabels = [].concat(this.flavorLabels);
      flavorLabels.forEach((item, i) => {
        item.selected = (index === i);
      });
      this.flavorLabels = flavorLabels;
    },
    onChangeDevice() {
      this.showSelectDevicePopup = true;
    },
    onProductChange(item, index) {
      this.myProducts.forEach((item, i) => {
        item.selected = (index === i);
      });
    },
    onApplyDevice() {
      const selectedItemIndex = this.myProducts.findIndex(item => item.selected);
      if (selectedItemIndex !== -1) {
        this.myProducts[selectedItemIndex].selected = true;
        this.productImage = this.myProducts[selectedItemIndex].deviceImage;
        this.productId = this.myProducts[selectedItemIndex].id;
      }
    },
    onCloseChooseDevicePopup() {
      setTimeout(() => {

        log(`product ID = ${this.productId}`);
        this.myProducts.forEach((item, i) => {
          item.selected = (this.productId == item.id);
        });
      }, 600);
    },

    async onDeleteClick() {
      this.showDeleteDialog = true;
    },
    async onDeleteFlavor() {
      console.log(`confirm delete flavor`);
      try {
        const resp = await produce.deleteFlavor({ id: this.$route.query.id }, true);
        if (resp.code === 1500) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return;
        }
        this.showDeleteDialog = false;
        this.$router.back();
      } catch (e) {
        console.log(e);
        this.$toast({
          type: "fail",
          message: e
        });
      }


    },
    async onCreateFlavor() {
      //检查参数
      const { brandId } = this.$route.query;
      if (!brandId) {
        this.$toast({
          type: "fail",
          message: "Invalid brand id"
        });
        return;
      }

      const productId = this.productId;
      if (!productId) {
        this.$toast({
          type: "fail",
          message: "Invalid device id"
        });
        return;
      }

      const flavorName = this.flavorName;
      if (!flavorName) {
        this.$toast({
          type: "fail",
          message: "Flavor name required "
        });
        return;
      }

      const selectedLabelId = this.flavorLabels.filter(item => item.selected).map(item => item.id);
      if (selectedLabelId.length === 0) {
        this.$toast({
          type: "fail",
          message: "Flavor label required"
        });
        return;
      }


      if (this.validateIngredients("ingredients")) {
        return;
      }
      if (this.validateIngredients("terpenes")) {
        return;
      }

      const params = {
        brandId,
        deviceId: productId,
        commodityLabelId: selectedLabelId.join(","),
        flavorName: this.flavorName,
        ingredientsVoList: this.ingredients.map(item => {
          return {
            id: item.id,
            name: item.text,
            proportion: item.value
          };
        }),

        terpenesList: this.terpenes.map(item => {
          return {
            id: item.id,
            name: item.text,
            proportion: item.value
          };
        })
      };
      const id = (this.$route.query && this.$route.query.id) || null;
      if (id) {
        params.id = id;
      }

      log(`${JSON.stringify(params)}`);
      try {
        const resp = await produce.addFlavor(params, true);
        if (resp.code !== 200) {
          this.$toast({
            message: resp.message
          });
          return;
        }
        await this.$toast({
          message: resp.message
        });
        this.$router.back();
      } catch (e) {
        log(e);
      }
    }
  },

  async mounted() {
    // this.productImage = this.$route.query.pi
    //获取数据
    if (this.$route.query.id) {
      this.showDelete = true;
    }
    const flavorLabels = await produce.flavorLabels();
    const myProducts = await produce.myProducts();

    const data = await produce.ingredients();
    let flavorInfo = null;
    if (this.$route.query.id) {

      flavorInfo = await produce.flavorInfo({ id: this.$route.query.id });
      this.flavorName = flavorInfo.flavorName;

      const ingredients = flavorInfo.ingredientsVoList.map(item => {
        return {
          id: item.id,
          text: item.name,
          value: `${item.proportion}`
        };
      });

      let terpenes = flavorInfo.terpenesList.map(item => {
        return {
          id: item.id,
          text: item.name,
          value: `${item.proportion}`
        };
      });

      if (ingredients.length === 0 && (flavorInfo.terpenesList || flavorInfo.terpenesList.length === 0)) {
        terpenes = [{
          text: "Other",
          value: "100",
          id: -1000
        }]
      }

      //第一次拿到数据就计算剩余的
      const result = [].concat(ingredients).concat(terpenes)
          .filter((item, i) => item.id > 0)
          .map(item => item.value)
          .reduce(
              (prev, current) =>
                  (parseFloat(prev) || 0) + (parseFloat(current) || 0),
              0
          );

      const idleIngredient = 100 - result;

      if (idleIngredient < 0) {
        if (terpenes.length > 0) {
          terpenes[terpenes.length - 1].value = terpenes[terpenes.length - 1].value + idleIngredient;
        } else {
          ingredients[ingredients.length - 1].value = ingredients[ingredients.length - 1].value + idleIngredient;
        }
        this.idleIngredient = 0;
      } else if (idleIngredient < 100 && idleIngredient > 0) {
        const other = terpenes.find(item => item.id === -1000);
        if (other) {
          other.value = idleIngredient;
        } else {
          this.otherTerpenes.value = idleIngredient;
          terpenes.push(this.otherTerpenes);
        }

        this.idleIngredient = 0;
      } else {
        this.idleIngredient = idleIngredient;
      }


      this.ingredients = ingredients;
      this.terpenes = terpenes;

      //口味

      const selectedFlavorIds = (flavorInfo && flavorInfo.labelList && flavorInfo.labelList.map(item => item.id));
      flavorLabels.forEach(item => {
        item.selected = selectedFlavorIds.includes(item.id) || false;
      });
    }

    this.productId = this.$route.query.productId;

    myProducts.forEach(item => {
      const selected = item.id == this.$route.query.productId;
      if (selected) {
        this.productImage = item.deviceImage;
      }
      item.selected = selected;

    });
    this.myProducts = myProducts;

    this.flavorLabels = flavorLabels;


    const intgredients = [].concat(data.ingredientsList);
    this.ingredientOptions = intgredients.map(item => {
      return {
        text: item.component,
        value: item.id,
        showSelectError: false,
        showInputError: false
      };
    });
    //
    const terpenes = [].concat(data.terpenesList);
    this.terpenesOptions = terpenes.map(item => {
      return {
        text: item.terpenesName,
        value: item.id,
        showSelectError: false,
        showInputError: false
      };
    });
  }
};
</script>

<style scoped lang="less">
.set-flavor-wrap {
  position: absolute;
  overflow-y: auto;
  width: 100%;
  height: calc(100vh - 44px - calc(70px + env(safe-area-inset-bottom)));
  margin-top: 44px;

  padding: 0 16px 16px 16px;

  & > * {
    margin-top: 12px;
  }
}
</style>
